import { PnetService } from '@previnet/service';
import { UserService as UserServiceInterface } from '@previnet/pnet-utils';
import Vue from 'vue';

export default class UserService extends PnetService implements UserServiceInterface {

  private _restPath: string = "" as string;
  private _changePasswordUrl: string = "" as string;
  private userData: null|any;

  constructor(restPath: string, opts?: any) {
    super({
      ...opts
    });
    this.restPath = restPath;
  }
  // this method is allowed for invalid password users, and can be used to trigger the
  // "change password" flow
  public async getUserData(): Promise<any> {
    //console.log(" getuserdata url = " + `${this.restPath}/api/edwin/user`);
    return this.userData ?
      Promise.resolve(this.userData) : 
      this.fetch(`${this.restPath}/api/edwin/user`, {}, {})
        .then((resp: Response) => {
          if (!resp.ok) {
            return Promise.reject();
          } else {
            return resp.json();
          }
        })
        .then((user: any) => {
          this.userData = user;
          return user;
        });
  }

  public checkPasswordChange(userData: any) {
    // TODO check route meta requireUserData
    if (this.userData && this.userData.needPasswordChange) {
      Vue.prototype.$router.push(this.changePasswordUrl);
    }
  }

  public get restPath() : string {
    return this._restPath;
  }
  public set restPath(v : string) {
    this._restPath = v;
  }

  public get changePasswordUrl() : string {
    return this._changePasswordUrl;
  }
  public set changePasswordUrl(v : string) {
    this._changePasswordUrl = v;
  }
}
